import { render, staticRenderFns } from "./ModalOrderDetailSummary.vue?vue&type=template&id=822ac06e&scoped=true&"
import script from "./ModalOrderDetailSummary.vue?vue&type=script&lang=js&"
export * from "./ModalOrderDetailSummary.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrderDetailSummary.vue?vue&type=style&index=0&id=822ac06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822ac06e",
  null
  
)

export default component.exports